import React, { useState, useContext, createContext} from 'react'
import { Router, unAuthRoutes } from './Routes/Routes';
import { useRoutes } from 'react-router-dom';

const AppContext = createContext()


const AppProvider = ({children})=>{
    const [user, setUser] =  useState(null);
    const [newUser, setNewUser] =  useState({});
    const [loading, setLoading] =  useState(false);


    return (
        <AppContext.Provider value ={{ 
            loading,
            setLoading,
            user,
            setNewUser,
            newUser,
            setUser
        }}
        >
            {children}

        </AppContext.Provider>
)

}

export const useGlobalContext = () => {
    return useContext(AppContext)
  }
  


export { AppContext, AppProvider }